export const ROLE_CONSTANT={
    SUPER_ADMIN:{
        name:'Super Admin',
        value:'superadmin'
    },
    ADMIN_CLIENT:{
        name:'Admin Client',
        value:"admin_client"
    },
    ADMIN_WM:{
        name:'Admin WM',
        value:"admin_wm"
    },
    USER_CLIENT:{
        name:'User Client',
        value:"user_client"
    },
    USER_WM:{
        name:'User WM',
        value:"user_wm"
    },
    WM:{
        name:'writemed'
    }    
} as const;

// [superadmin,admin_client,admin_wm,user_wm,user_client]